export default {"src":"/_next/static/media/close-icon.80826b0a.svg","height":27,"width":28};